import React from "react";
import {
  Typography,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles(() => ({
  version: {
    fontSize: 18,
  },
}));

const KmVersion = ({version,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Typography align="center" gutterBottom variant="h2" className={classes.version}>
      Wersja {version}
    </Typography>
  );
};

export default KmVersion;
